import { SearchParam } from 'types/Search/params';

export const getSelected = (
    isTransfer: boolean,
    isRailAndFlay: boolean,
    isPrivateTransfer: boolean
): string[] => {
    const selected = [];
    if (isTransfer) {
        selected.push(SearchParam.HotelTransfer);
    }
    if (isRailAndFlay) {
        selected.push(SearchParam.RailAndFly);
    }
    if (isPrivateTransfer) {
        selected.push(SearchParam.PrivateTransfer);
    }

    return selected;
};
